export class PanelMemberStatus {
  isPanelMember = false;
  isPanelChair = false;
  isReportAdmin = false;
}
